/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type TopicsListItem_topic$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type TopicsList_viewer$ref: FragmentReference;
export type TopicsList_viewer = {|
  +topics: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +hidden: ?boolean,
        +$fragmentRefs: TopicsListItem_topic$ref,
      |}
    |}>
  |},
  +$refType: TopicsList_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "TopicsList_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "topics",
      "storageKey": "topics(first:-1)",
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": -1,
          "type": "Int"
        }
      ],
      "concreteType": "TopicConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "TopicEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Topic",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "id",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "hidden",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "FragmentSpread",
                  "name": "TopicsListItem_topic",
                  "args": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'db665b4c2c056c1aab4090a40a99e6f0';
module.exports = node;



// WEBPACK FOOTER //
// src/components/topics/__generated__/TopicsList_viewer.graphql.js